import { render, staticRenderFns } from "./PersonalOrder.vue?vue&type=template&id=e49d8fa2&scoped=true&"
import script from "./PersonalOrder.vue?vue&type=script&lang=js&"
export * from "./PersonalOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e49d8fa2",
  null
  
)

export default component.exports